import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getExpertProfile = async (id) => {
  const { data, error } = await supabase
    .from('salons_profile')
    .select('*')
    .eq('id', id)
    .single();

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useExpertProfile(id: number) {
  return useQuery({
    queryKey: ['useExpertProfile', id],
    queryFn: () => getExpertProfile(id),
    enabled: Boolean(id),
    staleTime: 60000,
  })
}
